// Real-time event stream subscriber (Server-Sent Events)
// Connects to /api/events/stream and notifies listeners on backend events.
// Auto-reconnects via native EventSource behavior.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const STREAM_URL = `${BACKEND_URL}/api/events/stream`;

let source = null;
const listeners = new Set();
let connected = false;

const connect = () => {
  if (source) return;
  try {
    source = new EventSource(STREAM_URL);
    source.addEventListener('hello', () => { connected = true; });
    source.onmessage = (e) => {
      try {
        const evt = JSON.parse(e.data);
        listeners.forEach((cb) => {
          try { cb(evt); } catch (err) { console.error('SSE listener error', err); }
        });
      } catch (err) {
        console.warn('SSE bad payload', err);
      }
    };
    source.onerror = () => {
      // EventSource auto-reconnects; just mark as disconnected
      connected = false;
    };
  } catch (err) {
    console.error('SSE connect error', err);
  }
};

export const onRealtimeEvent = (callback) => {
  connect();
  listeners.add(callback);
  return () => listeners.delete(callback);
};

export const isRealtimeConnected = () => connected;
